import { Capacitor } from '@capacitor/core';

/** Returns true when running inside a Capacitor native shell (iOS/Android) */
export const isNative = () => Capacitor.isNativePlatform();

/** Returns 'ios' | 'android' | 'web' */
export const getPlatform = () => Capacitor.getPlatform();
